<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot-scope="scope" slot="menuLeft">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_SAFETY_GUARD_AGENT_ADD"
            @click.stop="handleAdd()"
          >新增</el-button>
          <el-button
            type="warning"
            icon="el-icon-delete"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_SAFETY_GUARD_AGENT_DEL"
            @click.stop="handleDel()"
          >删除</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="primary"
            icon="el-icon-edit"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_SAFETY_GUARD_AGENT_EDIT"
            @click.stop="handleEdit(scope.row, scope.index)"
          >编辑</el-button>
          <el-button
            type="success"
            icon="el-icon-link"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_SAFETY_GUARD_DEALER_BIND_ADD"
            @click.stop="handleBindDealer(scope.row)"
          >绑定经销商</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_SAFETY_GUARD_AGENT_DEL"
            @click.stop="handleRowDel(scope.row)"
          >删除</el-button>
        </template>
      </avue-crud>
      <dealer-bind-dialog
        :visible.sync="bindDealerDialogVisible"
        :agent-row="currentAgent"
        @update:visible="onDialogVisibleChange"
      ></dealer-bind-dialog>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { safetyGuardAgentOption } from '@/const/salesCloud/safetyGuardAgentOption';
import {
  findSafetyAgentPage,
  addSafetyAgent,
  editSafetyAgent,
  delSafetyAgent
} from '@/api/salesCloud/safetyGuard/agent';
import DealerBindDialog from '../components/DealerBindDialog.vue';

const SAFETY_AGENT_ERR_MSG = {
  '24026001': '代理商编码不能为空',
  '24026002': '代理商名称不能为空',
  '24026003': '代理商密钥不能为空',
  '24026004': '同一顶级部门下代理商编码已存在',
  '24026005': '代理商不存在或已删除',
  '24026006': '该商户已绑定安全卫士代理商'
};

export default {
  name: 'safetyGuardAgent',
  components: { DealerBindDialog },
  data() {
    return {
      tableOption: safetyGuardAgentOption,
      tableData: [],
      tableLoading: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      currentAgent: null,
      bindDealerDialogVisible: false
    };
  },
  created() {
    this.handleList();
  },
  computed: {
    ...mapGetters(['permission'])
  },
  methods: {
    showErr(res) {
      this.$message({
        showClose: true,
        message: SAFETY_AGENT_ERR_MSG[res && res.code] || (res && res.message) || '操作失败',
        type: 'error'
      });
    },
    handleList() {
      this.tableLoading = true;
      const params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findSafetyAgentPage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findSafetyAgentPage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      const params = this.$refs.crud.searchForm || {};
      params.page = this.page.currentPage;
      params.size = pageSize;
      findSafetyAgentPage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      const params = this.$refs.crud.searchForm || {};
      params.page = page;
      params.size = this.page.pageSize;
      findSafetyAgentPage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      const params = this.$refs.crud.searchForm || {};
      params.page = page.currentPage;
      params.size = page.pageSize;
      findSafetyAgentPage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.$refs.crud.rowEdit(row, index);
    },
    handleSave(row, done) {
      if (!row.agentSecret) {
        this.$message({
          showClose: true,
          message: '请输入接口密钥',
          type: 'error'
        });
        done();
        return;
      }
      addSafetyAgent(row).then(res => {
        if (res && res.code == '200') {
          this.$message({
            showClose: true,
            message: '添加成功',
            type: 'success'
          });
          this.handleList();
        } else {
          this.showErr(res);
        }
        done();
      }).catch(err => {
        this.$message({
          showClose: true,
          message: (err && err.message) || '请求失败',
          type: 'error'
        });
        done();
      });
    },
    handleUpdate(row, index, done) {
      // 留空密钥则不修改
      if (!row.agentSecret) {
        delete row.agentSecret;
      }
      editSafetyAgent(row).then(res => {
        if (res && res.code == '200') {
          this.$message({
            showClose: true,
            message: '编辑成功',
            type: 'success'
          });
          this.handleList();
        } else {
          this.showErr(res);
        }
        done();
      }).catch(err => {
        this.$message({
          showClose: true,
          message: (err && err.message) || '请求失败',
          type: 'error'
        });
        done();
      });
    },
    confirmAndDelete(ids, successMsg) {
      this.$confirm('是否确认删除所选代理商？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delSafetyAgent(ids).then(res => {
          if (res && res.code == '200') {
            this.$message({
              showClose: true,
              message: successMsg || '删除成功',
              type: 'success'
            });
            this.handleList();
          } else {
            this.showErr(res);
          }
        }).catch(err => {
          this.$message({
            showClose: true,
            message: (err && err.message) || '请求失败',
            type: 'error'
          });
        });
      }).catch(() => {});
    },
    handleDel() {
      const rows = this.$refs.crud.tableSelect;
      if (!rows || rows.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择要操作的数据',
          type: 'error'
        });
        return;
      }
      const ids = rows.map(r => r.id).join(',');
      this.confirmAndDelete(ids);
    },
    handleRowDel(row) {
      this.confirmAndDelete(String(row.id));
    },
    handleBindDealer(row) {
      this.currentAgent = row;
      this.bindDealerDialogVisible = true;
    },
    onDialogVisibleChange(val) {
      if (!val) {
        this.currentAgent = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>